import { Image } from '@/components'
import Link from '@/features/ref/components/Link'

export const AdsBlogs = () => {
  return (
    <>
      {Array.from({ length: 2 }, (_, index) => (
        <Link target="_blank" key={index} href={'/danh-muc-san-pham/'} rel="noreferrer">
          <Image
            key={index}
            src={`/assets/images/temp_decor_blog/decor-ad-${index + 1}.jpg`}
            alt="Banner"
            style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
          />
        </Link>
      ))}
    </>
  )
}
